import { css } from "@emotion/react";
import { ManagementViewTitle } from "../bits/ManagementViewTitle";
import { useUser } from "../hooks/useUser";
import { Bookshelf } from "../patterns/Bookshelf";
import { HomeSectionHeader } from "../patterns/HomeSectionHeader";
import { RecentActivity } from "../patterns/RecentActivity";
import { RecentAnnotations } from "../patterns/RecentAnnotations";
import { useTitle } from "../hooks/useTitle";
import { FrjLatestPosts } from "../patterns/FrjLatestPosts";

export const Home = () => {
  useTitle("Home | Compass");
  const { user } = useUser();
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 24px;
        gap: 24px;
      `}
    >
      <ManagementViewTitle text="Home" />
      <div
        css={({ breakpoints }) => css`
          display: flex;
          flex-direction: column;
          padding: 0 70px;
          width: 100%;

          @media (max-width: ${breakpoints.values.xl}px) {
            padding: 0;
          }
        `}
      >
        {!!user?.recentSearches.length && (
          <>
            <HomeSectionHeader
              title="Recent searches"
              linkTo="/my-recent-searches"
              linkTitle="View recent searches"
            />

            <RecentActivity
              css={css`
                max-height: 230px;
                overflow: hidden;
              `}
              homeView
            />
          </>
        )}
        {user?.frjAccess && (
          <>
            <HomeSectionHeader
              css={css`
                margin-top: 16px;
              `}
              title="Financial Remedies Journal"
              linkTo="/frj"
              linkTitle="View all articles"
            />
            <FrjLatestPosts
              css={css`
                margin-top: 16px;
              `}
            />
          </>
        )}
        <HomeSectionHeader
          title="Recent titles"
          linkTo="/my-shelf"
          linkTitle="View my shelf"
        />

        <Bookshelf
          homeView
          css={({ breakpoints }) => css`
            height: 342px;

            @media (max-width: ${breakpoints.values.xl}px) {
              height: 280px;
            }
          `}
        />
        <HomeSectionHeader
          title="Recent highlights and notes"
          linkTo="/annotations"
          linkTitle="View all highlights and notes"
        />
        <RecentAnnotations />
      </div>
    </div>
  );
};
